import { Component, Renderer2, Inject, OnInit } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { inIFrame } from '../utils'

@Component({
  selector: 'embed-video',
  template: `
    <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
      <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
        <div  class="wistia_embed wistia_async_{{vidId}} videoFoam=true" style="height:100%;position:relative;width:100%">
          <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
            <img src="https://fast.wistia.com/embed/medias/{{vidId}}/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />
          </div>
        </div>
      </div>
    </div>
  `
})
export class EmbedVideo implements OnInit {
  vidId: string

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document
  ) {}

  ngOnInit(): void {
    const isSignupOrWww = window.location.pathname.includes('signup') || inIFrame()
    this.vidId = isSignupOrWww ? 'n148whykqv' : '6ho60tblva'

    const media = this.renderer2.createElement('script')
    media.src = `https://fast.wistia.com/embed/medias/${this.vidId}.jsonp`
    this.renderer2.appendChild(this._document.body, media)

    const asset = this.renderer2.createElement('script')
    asset.src = "https://fast.wistia.com/assets/external/E-v1.js"
    this.renderer2.appendChild(this._document.body, asset)
  }
}
